/* eslint-disable import/prefer-default-export */
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, Inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie';
import { L10nLocale, L10N_LOCALE, L10nConfig, L10N_CONFIG, L10nTranslationService } from 'angular-l10n';
import { LanguageService } from 'src/app/service-pool/language-service/language.service';
import { ContentDetailsService } from 'src/app/service-pool/content-details/content-details.service';
import { GetIdService } from 'src/app/service-pool/get-id-service.service';
import { skip, switchMap } from 'rxjs';
import { ChildMessageService } from '../../service-pool/child-message-service/child-message.service';
import { CONFIG } from '../../model/config';
import { LogoffService } from '../../service-pool/business-services/logoff-service/logoff.service';
import { LoginService } from '../../service-pool/login-service/login.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  @Input() header: string;

  @Input() internalPage: boolean;

  @Input() selectedLangAbbrv: string;

  @Output() childPathNavigation = new EventEmitter();

  loggedIn: boolean;

  brand: string;

  showCanadian = false;

  logoSrc: string;

  childCanDeactive: boolean;

  config: object;

  userName: string;

  showLanguageSelect = false;

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    @Inject(L10N_CONFIG) private l10nConfig: L10nConfig,
    private loginService: LoginService,
    private cookieService: CookieService,
    protected _sanitizer: DomSanitizer,
    private childMessageService: ChildMessageService,
    private logOffService: LogoffService,
    private languageService: LanguageService,
    private dateTimeId: GetIdService,
    private contentDetailsService: ContentDetailsService,
    private translationService: L10nTranslationService
  ) {
    this.loggedIn = false;
    this.childCanDeactive = false;
    this.config = CONFIG;
  }

  ngOnInit() {
    // Moved this logic outside of is logged in. it should run regardless of whether we are logged in or not.
    this.brand = this.cookieService.get('bid');
    this.showCanadian = !!this.brand?.toUpperCase().includes('CA');
    this.childMessageService.canDeactiveChildApp().subscribe((canDeactive) => {
      this.childCanDeactive = canDeactive;
    });
    if (!this.internalPage) {
      this.contentDetailsService.getContentForLS().subscribe({
        next: () => {
          this.logoSrc = this.logoSourceCreation() || `/assets/public/${this.brand}/images/Logo.png`;
        },
        error: () => {
          this.logoSrc = `/assets/public/${this.brand}/images/Logo.png`;
        }
      });

      this.translationService
        .onChange()
        .pipe(
          skip(1),
          switchMap(() => {
            this.contentDetailsService.clearContentCache();
            return this.contentDetailsService.getContentForLS();
          })
        )
        .subscribe({
          next: () => {
            this.logoSrc = this.logoSourceCreation() || `/assets/public/${this.brand}/images/Logo.png`;
          },
          error: () => {
            this.logoSrc = `/assets/public/${this.brand}/images/Logo.png`;
          },
        });
    }

    this.loginService.getLoggedIn().subscribe((loggedIn) => {
      this.loggedIn = loggedIn;
      if (loggedIn) {
        this.userName = this.loginService.getUser();
      }
    });
    const sessionLocale = JSON.parse(sessionStorage.getItem('locale'));
    this.selectedLangAbbrv = sessionLocale.language.split('-')[0].toUpperCase();

    this.languageService.getLanguageBarStatus().subscribe((languageFlag) => {
      this.showLanguageSelect = languageFlag;
    });
  }

  safeHtml(html) {
    // eslint-disable-next-line no-underscore-dangle
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  navigate(path, child?) {
    const canNavigate = this.childMessageService.canNavigate(this.childCanDeactive, path, child);
    if (!canNavigate) {
      return false;
    }
    this.childPathNavigation.emit({ path, child });
    return false;
  }

  toggleLanguage() {
    // this.showLanguageSelect = !this.showLanguageSelect;
    this.languageService.setLanguageBarStatus(this.showLanguageSelect);
  }

  logOffClicked() {
    this.logOffService.logOff();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  logoSourceCreation(): string {
    const homeLogo = this.contentDetailsService.getProgramContentByPosition('Home Logo');
    if (homeLogo && (homeLogo as any)?.error === true) {
      return `/assets/public/${this.brand}/images/Logo.png`;
    }
    if (homeLogo && homeLogo.items) {
      return homeLogo.items[0].contentPath;
    }
    return `/assets/public/${this.brand}/images/Logo.png`;
  }
}
